import { render, staticRenderFns } from "./AddWeekly.vue?vue&type=template&id=6ba0b4f0&scoped=true"
import script from "./AddWeekly.vue?vue&type=script&lang=js"
export * from "./AddWeekly.vue?vue&type=script&lang=js"
import style0 from "./AddWeekly.vue?vue&type=style&index=0&id=6ba0b4f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0b4f0",
  null
  
)

export default component.exports